/**
 * sessionTimeout.js
 *
 * Cookie-based session timeout utility for auto-logout after N days.
 * Browser handles cookie expiration automatically.
 */

import { SESSION_TIMEOUT_DAYS } from '@/config/constants'

const SESSION_COOKIE_NAME = 'syft_session'

/**
 * Sets a session cookie with configured expiration.
 * Call on successful login.
 */
export function setSessionCookie() {
  const maxAgeSeconds = SESSION_TIMEOUT_DAYS * 24 * 60 * 60
  document.cookie = `${SESSION_COOKIE_NAME}=active; max-age=${maxAgeSeconds}; path=/; SameSite=Strict`
}

/**
 * Clears the session cookie.
 * Call on logout.
 */
export function clearSessionCookie() {
  document.cookie = `${SESSION_COOKIE_NAME}=; max-age=0; path=/; SameSite=Strict`
}

/**
 * Checks if the session cookie has expired.
 * Returns true if cookie is missing (expired or never set).
 */
export function isSessionExpired() {
  const cookies = document.cookie.split('; ')
  return !cookies.some(c => c.startsWith(`${SESSION_COOKIE_NAME}=`))
}
